import { defineMessages } from 'react-intl';

export default defineMessages({
  adhoc: {
    id: 'frequently.adhoc.title',
    defaultMessage: 'Ad-hoc'
  },
  daily: {
    id: 'frequently.daily.title',
    defaultMessage: 'Daily'
  },
  weekly: {
    id: 'frequently.weekly.title',
    defaultMessage: 'Weekly'
  },
  monthly: {
    id: 'frequently.monthly.title',
    defaultMessage: 'Monthly'
  },
  quarterly: {
    id: 'frequently.quarterly.title',
    defaultMessage: 'Quarterly'
  },
  halfyearly: {
    id: 'frequently.halfyearly.title',
    defaultMessage: 'Half-yearly'
  },
  annually: {
    id: 'frequently.annually.title',
    defaultMessage: 'Annually'
  }
});